var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgKosher = function SvgKosher(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.033 5.651v.535A3.018 3.018 0 0 1 6.505 8.81l.173.623a3.087 3.087 0 0 0 2.584-2.865l.047-.8.999.06-.047.798a4.086 4.086 0 0 1-3.825 3.839.62.62 0 0 1-.635-.453L4.67 5.95l.964-.268.59 2.12c.5-.374.808-.969.808-1.615V5.65h1ZM1 7.205a2.358 2.358 0 0 1 2.358 2.359v.816h1v-.816A3.358 3.358 0 0 0 1 6.205v1Zm13.8 2.161a2.57 2.57 0 0 0-2.654-3.188l-.943.06.063.997.942-.058a1.57 1.57 0 0 1 1.62 1.947.19.19 0 0 1-.183.144h-2.412v1h2.412a1.19 1.19 0 0 0 1.154-.902Z",
    fill: "currentColor"
  })));
};
export default SvgKosher;